import { useCallback, useState } from "react";
// import { API } from "aws-amplify";
import { DocListObj } from "../types/document";
import { useLoginUser } from "./providers/useLoginUserProvider";
import { useUser } from "./useUser";
import { API } from 'aws-amplify';
import { Buffer } from 'buffer';

// ドキュメント関連
export const useDocument = () => {
  const {loginUser} = useLoginUser();
  const {refreshToken} = useUser();
  const [executing, setExecuting] = useState(false);
  const [docList, setDocList] = useState<DocListObj|undefined>(undefined);
  const [docURL, setDocURL] = useState("");
  const [result, setResult] = useState<string>('');
  const [errObj, setErrObj] = useState(null);
  const [opeErrMes] = useState("");
    
  // ドキュメント一覧取得
  const GetDocumentList = useCallback(async() => {
    setExecuting(true);
    
    const apiName = 'BackendApi';
    const path = '/document/list';
    const token = await refreshToken();
    
    // パラメータ設定
    const params = {
      headers: {
        'X-NecAuth-Token': token
      },
    };
    loginUser.envType === 'DEV' && console.log("getDocumentList_params",params);
    
    (async() => {
      await API.get(apiName, path, params)
      .then(res => {
        loginUser.envType === 'DEV' && console.log("getDocumentList_res",res);
        setDocList(res);
      })
      .catch(err => {
        setErrObj(err);
      })
      .finally(() => {
        setExecuting(false);
      });
    })();
    
  }, []);
      
  // ドキュメントURL取得
  const GetDocumentURL = useCallback(async(documentId:string) => {
    setExecuting(true);
    
    const apiName = 'BackendApi';
    const path = '/document/url';
    
    // パラメータ設定
    const params = {
      headers: {
        // Authorization: token,
        'X-NecAuth-Token': await refreshToken()
      },
      queryStringParameters: {
        documentId: documentId,
      }
    };
    loginUser.envType === 'DEV' && console.log("getDocumentURL_params",params);
    
    (async() => {
      await API.get(apiName, path, params)
      .then(res => {
        loginUser.envType === 'DEV' && console.log("getDocumentURL_res",res);
        setDocURL(res.url);
      })
      .catch(err => {
        setErrObj(err);
      })
      .finally(() => {
        setExecuting(false);
      });
    })();
    
  }, []);
        
  // ドキュメントURL取得
  const GetDocumentDownload = useCallback(async(documentId:string,documentName:string) => {
    setExecuting(true);
    
    const apiName = 'BackendApi';
    const path = '/document/download';
    
    // パラメータ設定
    const params = {
      headers: {
        // Authorization: token,
        'X-NecAuth-Token': await refreshToken()
      },
      queryStringParameters: {
        documentId: documentId,
      }
    };
    loginUser.envType === 'DEV' && console.log("getDocumentDownload_params",params);
    
    (async() => {
      await API.get(apiName, path, params)
      .then((res) => {
        // responseの先頭のbは除く
        const data = res.substring(1);
        const b64encode = Buffer.from(data, 'base64');
        
        // BOM付きUTF-8
        const bom = new Uint8Array([0xef, 0xbb, 0xbf]);
        const blob = new Blob([bom, b64encode], {
          type: 'application/octet-stream',
        });
  
        // if (window.navigator.msSaveBlob) {
        //   // IEとEdge
        //   window.navigator.msSaveBlob(blob, file_name);
        // } else {
          // それ以外のブラウザ
          const anchor = document.createElement('a');
          const url = window.URL.createObjectURL(blob);
          document.body.appendChild(anchor);
          anchor.href = url;
          anchor.setAttribute('download', documentName);
          anchor.click();
          document.body.removeChild(anchor);
          
          loginUser.envType === 'DEV' && console.log('getDocumentDownload_res', anchor);
          window.URL.revokeObjectURL(url);
        // }
          setResult('download');
      })
      .catch((err) => {
        setErrObj(err);
      })
      .finally(() => {
        setExecuting(false);
      });
    })();
  }, []);
  
  return {
    GetDocumentList,
    docList,
    GetDocumentURL,
    docURL,
    GetDocumentDownload,
    result,
    setDocURL,
    executing,
    errObj,
    opeErrMes,
  };
};